import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import { metadataService } from '../../_services/metadata.service'
//import { connect } from "react-redux";
//import { Alert } from 'reactstrap';
//import validator from 'validator';


export class SelectInput extends Component {
    constructor(props) {
        super(props);
        this.state = { visited: false }
        this.handleOnBlur = this.handleOnBlur.bind(this);
    }
    handleOnBlur() {
        this.setState({ visited: true })
    }
    render() {
        const fieldLabel = this.props.label ? this.props.label : metadataService.getFieldNameLabel(this.props.name);
        let errorMessage = null;
        let hasError = false;

        if (this.props.isRequired && this.state.visited) {
            hasError = this.props.value === '';
            errorMessage = metadataService.getMessage('RequiredFieldNotSupplied', fieldLabel);
        }

        return (
            <FormGroup>
                <Label for={this.props.name} hidden={!this.props.showLabel} className={ "text-input-label" +  (this.props.isRequired && !this.props.disabled ? " required" : "")}>
                    {metadataService.getFieldNameLabel(this.props.customLabel ? this.props.customLabel : this.props.name)}
                </Label><br />
                <Input
                    type='select'
                    id={this.props.name + '_id'}
                    name={this.props.name}
                    invalid={hasError}
                    className={ "text-field-margin" + (this.props.value === '' ? " placeholder" : "")}
                    value={this.props.value}
                    disabled={this.props.disabled}
                    onBlur={this.handleOnBlur}
                    onChange={this.props.onChange} placeholder={this.props.placeholder}>
                    <option value=''>{(this.props.placeholder ? this.props.placeholder : metadataService.getLabel('Select'))}</option>
                    {this.props.options.map(function(option) {
                        return <option value={option.value} key={option.value}>{option.text ? option.text : option.value }</option>
                    })}
                </Input>
                {hasError && (<FormFeedback>{errorMessage}</FormFeedback>)}
            </FormGroup>
        );
    }
}

//Define prop types
SelectInput.propTypes = {
    name: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired, 
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
    error: PropTypes.string,
    placeholder: PropTypes.string, 
    showLabel: PropTypes.bool,
    isRequired: PropTypes.bool,
    customLabel: PropTypes.string,
}
SelectInput.defaultProps = {
    disabled:false, 
    showLabel: true,
    isRequired: true
}